module.exports = __webpack_public_path__ + "static/media/TT.e0558348.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/TT.svg
// module id = 379
// module chunks = 0